<template>
    <div class="v-password-find">
        <hua-form :label-width="120" :input-align="'right'">
            <hua-field type="number" v-model="phoneNumber" label="手机号" placeholder="请输入" />
            <hua-field
                v-model="password"
                label="新密码"
                placeholder="请输入"
                @blur="validatePassword"
            />
            <!-- <hua-field v-model="validateCode" label="验证码" placeholder="请输入" /> -->
            <hua-field v-model="validateCode" label="验证码" center placeholder="请输入">
                <template #button>
                    <span
                        class="spanSty"
                        v-show="!sendstatus && !sendagain"
                        @click="getVilidateCode"
                        >获取验证码</span
                    >
                    <span class="textColor" v-show="sendstatus">({{ second }}s)后重新发送</span>
                    <span class="spanSty" v-show="sendagain" @click="getVilidateCode"
                        >重新发送</span
                    >
                </template>
            </hua-field>
        </hua-form>
        <div class="v-submit-btn">
            <hua-button type="primary" block round @click="findPassword">确 认</hua-button>
        </div>
    </div>
</template>

<script>
import api from '@/constants/api'

export default {
    data() {
        return {
            phoneNumber: '',
            password: '',
            validateCode: '',
            sendstatus: false,
            sendagain: false,
            second: 60,
            passReg: /^[a-zA-Z0-9]$/,
            regMobile: new RegExp('^1[3|4|5|7|8|9][0-9]{9}$'),
        }
    },
    methods: {
        /**
         * @method findPassword() 确认提交
         * */
        findPassword() {
            let params = {
                password: this.password,
                phoneNumber: this.phoneNumber,
                validateCode: this.validateCode,
            }
            api.findPassword(params)
                .then((res) => {
                    if (res.success) {
                        this.$toast('修改成功')
                        this.$router.push({ path: '/index' })
                    }
                })
                .catch((err) => {
                    this.$toast(err.errMsg)
                })
        },

        /**
         * @method getVilidateCode() 获取验证码
         * */
        getVilidateCode() {
            let _phoneNum = this.phoneNumber
            if (!_phoneNum) {
                return this.$toast('请输入手机号')
            } else if (!this.regMobile.test(_phoneNum)) {
                return this.$toast('手机号码不正确！')
            }
            this.sendstatus = true
            this.sendagain = false
            const timer = setInterval(() => {
                if (this.second > 1) {
                    this.second -= 1
                } else {
                    this.sendagain = true
                    this.sendstatus = false
                    this.second = 60
                    clearInterval(timer)
                }
            }, 1000)
            api.getValidCode(_phoneNum)
                .then((res) => {
                    console.log(res)
                })
                .catch((err) => {
                    this.$toast(err.errMsg)
                })
        },
        /**
         * @method validatePassword() 密码校验
         * */
        validatePassword() {
            if (!this.password) {
                this.$toast('请输入新密码')
            } else if (!this.passReg.test(this.password)) {
                this.$toast('密码仅支持数字和字母')
            }
        },
    },
}
</script>

<style lang="less">
.v-password-find {
    .v-submit-btn {
        margin: 50px 20px 20px;
    }
    .spanSty {
        color: #0a86ff;
        cursor: pointer;
    }
    .textColor {
        color: #bfbfbf;
    }
}
</style>